module.exports = __webpack_public_path__ + "img/labmemtest_text_btn01_sc.9373fca1.png";